import { render, staticRenderFns } from "./OverduePayments.vue?vue&type=template&id=c30529c6&scoped=true&"
import script from "./OverduePayments.vue?vue&type=script&lang=js&"
export * from "./OverduePayments.vue?vue&type=script&lang=js&"
import style0 from "./OverduePayments.vue?vue&type=style&index=0&id=c30529c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30529c6",
  null
  
)

export default component.exports